import React, { useEffect, useState } from "react";
import BasvuruFormuModulservice from "../../../service/Ebasvuru/AdayDomain/BasvuruFormuModulService";
import { HeaderText } from "../../../menu/muiStyles";
import BoxContainer from "../../../components/container/BoxContainer";
import ModullerComponent from "./ModullerComponent";
import { ShareProvider, useShareContext } from "./BasvuruContext";
import { Box, Button, Card, CardActions, CardContent, Grid } from "@mui/material";
import useGlobal from "../../../util/Global";
import { NavigateBeforeOutlined, NavigateNext, NavigateNextOutlined } from "@mui/icons-material";

const BlokerComponent = ({ basvuruFormBlokId = null, moveBlokler, isFinish }) => {
    const {
        saveKriterler,
        isChange,
        setConfirmOpen,
        setDialogTitle,
        setDialogMessage,
        setOnConfirm,
        onConfirm,
        isPageValid,
        setbasvuruFormBlokId } = useShareContext();
    const [moduller, setModuller] = useState([]);
    const { t } = useGlobal();


    useEffect(() => {
        if (basvuruFormBlokId) {
            setbasvuruFormBlokId(basvuruFormBlokId);

            BasvuruFormuModulservice.fullGet({
                filter: {
                    BasvuruFormBlokId: basvuruFormBlokId,
                    aktif: true
                },
                order: [
                    { key: "siralama", value: "asc" },
                    { key: "modulDisplay", value: 'asc' }
                ]
            }).then((res => {
                if (res && res.isSuccess) {
                    //     console.log(basvuruFormBlokId);
                    setModuller(res.resultObject);
                }
            }));
        }


    }, [basvuruFormBlokId]);

    const confirmMessage = () => {
        // setOnConfirm(saveKriterler);

        setDialogMessage(t('message.confirmSaveBasvuru'));
        setDialogTitle(t('title.confirmDialogTitle'));
        setConfirmOpen(true);
    }

    return (
        <Card sx={{ minHeight: '70vh' }}>
            <CardActions>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Button
                            sx={{ minWidth: 100 }}
                            startIcon={<NavigateBeforeOutlined />}
                            color="primary"
                            variant="contained"
                            onClick={() => moveBlokler(false)}
                        >
                            {t("action.previous")}
                        </Button>
                    </Grid>
                    <Grid item>

                    </Grid>
                    <Grid item>
                        {isFinish && (
                            <Button
                                sx={{ minWidth: 100 }}
                                onClick={() => confirmMessage()}
                                color="danger"
                                disabled={isPageValid}
                                variant="contained">
                                {t("button.save")}
                            </Button>
                        )}

                        {!isFinish &&
                            (<Button
                                sx={{ minWidth: 100 }}
                                endIcon={<NavigateNextOutlined />}
                                color="primary"
                                variant="contained"
                                disabled={isPageValid}
                                onClick={() => moveBlokler(true)}
                            >
                                {t("action.next")}
                            </Button>)
                        }
                    </Grid>
                </Grid>
            </CardActions>


            <CardContent >
                <div style={{ height: '62vh', overflowY: 'auto' }}>
                    <BoxContainer color="light" boxSx={{ textAlign: "left" }} >
                        {moduller.map((module, index) => (

                            <React.Fragment key={module.modulId}> {/* Use a unique key */}
                                <ModullerComponent
                                    key={"Con-" + module.modulId}
                                    modulId={module.modulId}
                                    moduleName={module.modulDisplay} />
                            </React.Fragment>
                        ))}
                    </BoxContainer>
                </div>
            </CardContent>


        </Card >


    );


}

export default BlokerComponent;